module.exports = __webpack_public_path__ + "static/media/danger_board_Clamp.30fa047a.webp";